<template>
  <el-table
    show-summary
    :data="data"
    border
    style="width: 100%"
    size="mini"
  >
    <el-table-column
      fixed="left"
      align="center"
      label="序号"
      type="index"
      width="60"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="number"
      label="外发编号"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="outgoingNumber"
      label="外发承运单号"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="carrierName"
      label="承运商"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="outgoingRemarks"
      label="外发备注"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="sendMethod"
      label="送货方式"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="sendEmployeeName"
      label="发货人"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="applyReimburseStatus"
      label="是否申请报销"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="totalAmount"
      label="实际费用合计"
    ></el-table-column>
    <!-- <el-table-column
                    align="center"
                    prop="amount"
                    label="实际费用"
                  ></el-table-column>-->
    <el-table-column
      align="center"
      prop="basicFreight"
      label="实际运费"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="sendFee"
      label="实际送货费"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="allOtherFee"
      label="实际其他费用"
    ></el-table-column>
  </el-table>
</template>

<script>
export default {
    props:{
        data:{
            default(){
                return []
            }
        }
    }
};
</script>

<style>
</style>